
















































import Enumerable from "linq";
import Moment from "moment";
import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import { Table, TableColumn } from "element-ui";
import { SortOrder } from "element-ui/types/table";
import InfiniteLoading from "vue-infinite-loading";
import { EditableFormatSummary } from "../../../domain/editableFormat";
import { ISortParameter } from "../../../../base/components/system";
import { ModelEditableMixin, ForceUseInfiniteWrapperForInfiniteLoadingMixin } from "../../../../base/components/system/mixins";
import { Directory } from "../../../../base/domain/drawing";

@Component({
  components: {
    InfiniteLoading,
  },
})
export default class FormatTableSelector extends Mixins(ModelEditableMixin, ForceUseInfiniteWrapperForInfiniteLoadingMixin) {
  @Prop()
  formats: EditableFormatSummary[];

  @Prop()
  sortParameter: ISortParameter;

  @Prop({ default: false})
  multiSelect: boolean;

  @Prop()
  formatTree: Directory<number, EditableFormatSummary>[];

  get highlightCurrentRow(): boolean {
    return !this.multiSelect;
  }

  get hasFormats(): boolean {
    return (0 < this.formatCount);
  }

  get formatCount(): number {
    return this.formats.length;
  }

  get loadChunkSize(): number {
    // TODO: コンフィグ追加する
    // const settingCount = this.$configuration.behavior.document.list.infiniteLoader.rowCount;
    // return settingCount ? settingCount : 30; // 設定がなかった時のためにデフォルト値
    return 30;
  }

  get displayPath(): boolean {
    return !!this.formatTree;
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  @Watch("formats")
  onFormatsUpdated(newValue: EditableFormatSummary[], oldValue: EditableFormatSummary[]): void {
    this.$logger.debug("onFormatsUpdated..");
    this.input(null);

    this.loadedFormats = [];
    this.chunkedCount = 0;

    if (this.$refs.infiniteLoading) {
      this.$logger.debug("call reset.");
      this.$refs.infiniteLoading.stateChanger.reset();
    }
  }

  @Watch("sortParameter")
  onSortParameterUpdated(newValue: ISortParameter, oldValue: ISortParameter): void {
    if (!oldValue || (newValue.property !== oldValue.property || newValue.order !== oldValue.order)) {
      this.updateSort();
    }
  }

  data(): any {
    return {
      chunkedCount: 0,
      loadedFormats: [],
    };
  }
  chunkedCount: number;
  loadedFormats: EditableFormatSummary[];

  $refs!: {
    table: Table,
    infiniteLoading: InfiniteLoading
  };

  mounted(): void {
    this.updateForceUseInfiniteWrapper(this.$refs.table.$el as HTMLElement, this.$refs.infiniteLoading);
    this.updateSort();
  }

  toPathName(source: EditableFormatSummary): string {
    if (!this.displayPath) {
      return "";
    }
    let name = "";
    this.formatTree.some(element => {
      const path = this.getPathName(element, source.id);
      if (!!path) {
        name = path;
        return true;
      }
    });
    return name;
  }

  private getPathName(folder: Directory<number, EditableFormatSummary>, formatId: number): string {
    if (Enumerable.from(folder.entities).any(e => e.id === formatId)) {
      return folder.name;
    }

    let path = "";
    folder.nodes.some(f => {
      const result = this.getPathName(f, formatId);
      if (!!result) {
        path = f.name + " / " + result;
        return true;
      }
    });
    return path;
  }

  toStatusString(source: EditableFormatSummary): string {
    return (source.deleted)
      ? "削除"
      : ((source.isTemporary)
        ? "一時保存" : "");
  }

  toDateString(source: Date): string {
    return Moment(source).format("YY/MM/DD");
  }

  toTimeString(source: Date): string {
    return Moment(source).format("HH:mm");
  }

  onInfinite(): void {
    this.$logger.debug("onInfinite");
    this.chunkList();
    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.table));
  }

  private chunkList(): void {
    this.$logger.debug("chunkList");
    for (let i = this.chunkedCount; i < (this.chunkedCount + this.loadChunkSize); i++) {
      if (i >= this.formats.length) {
        this.$logger.debug("call complete. i is " + i);
        this.$refs.infiniteLoading.stateChanger.complete();
        return;
      }

      this.loadedFormats.push(this.formats[i]);
    }
    this.chunkedCount += this.loadChunkSize;

    this.$logger.debug("call loaded. chunkedCount is " + this.chunkedCount);
    this.$refs.infiniteLoading.stateChanger.loaded();
  }

  clearSelection() {
    this.$refs.table.setCurrentRow();
  }

  updateSort(): void {
    if (this.$refs.table && this.sortParameter) {
      this.$refs.table.sort(this.sortParameter.property, this.sortParameter.order);
    }
  }

  onSortChanged(param: { column: TableColumn, prop: string, order: SortOrder }): void {
    // element-uiのテーブルソートは ascending → descending → null となるため null の場合は ascending とする
    const parameter: ISortParameter = {
      property: param.prop,
      order: param.order ? param.order : "ascending"
    };
    this.$emit("sortChange", parameter);
  }

  async handleSelectionChanged(row: EditableFormatSummary): Promise<void> {
    this.editingSource = row;
  }

  onRowDoubleClicked(): void {
    this.dblclick(this.editingSource);
  }

  @Emit()
  dblclick(source: EditableFormatSummary): void {}

  @Emit()
  selectionChanged(value: EditableFormatSummary[]): void {}
}
